import React from 'react'
import PropTypes from 'prop-types'
import i18n from '../../../Utils/I18nUtil'
import styled from 'styled-components'
import {darken, desaturate, lighten} from 'polished/lib/index'
import Label from '../Atoms/Label'

const SwitchButtons = ({trueLabel, falseLabel, value = true, onChange, color = '#36a1c9', label}) => {
    return (
        <div>
            <LabelWrapper>
                <Label color={'#0b5f99'}>
                    {label}
                </Label>
            </LabelWrapper>
            <SwitchButton deactivated={value === false} onClick={event => onChange(true)} color={color}>
                {i18n(trueLabel)}
            </SwitchButton>
            <SwitchButton deactivated={value === true} onClick={event => onChange(false)} color={color}>
                {i18n(falseLabel)}
            </SwitchButton>
        </div>
    )
}

SwitchButtons.propTypes = {
    value: PropTypes.bool,
    trueLabel: PropTypes.string,
    falseLabel: PropTypes.string,
    onChange: PropTypes.func,
}

export default SwitchButtons

const SwitchButton = styled.button`
    background-color: ${(props) => {
        if (props.color && props.deactivated) {
            return desaturate(0.1, lighten(0.4, props.color))
        } else if (props.color && !props.deactivated) {
            return props.color
        } else if (!props.color && props.deactivated) {
            return 'grey'
        } else if (!props.color && !props.deactivated) {
            return 'black'
        }
    }};
    border: none;
    color: ${props => props.deactivated ? props.color : 'white'};
    padding: 10px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    width: 50%;
    font-size: 16px;
    cursor: pointer;
    transition: all .3s ease;
    &:focus{
       outline:0;
    }
    &:first-of-type {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
    }
    &:last-of-type {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
    }
    ${props => {
        if (props.deactivated) {
            return (`
                &:hover{
                    background-color: ${props.color ? darken(0.1, desaturate(0.1, lighten(0.4, props.color))) : darken(0.1, 'grey')};
                }
                &:active {
                    box-shadow: inset 0 2px 6px rgba(0,0,0,0.24), inset 0 2px 4px rgba(0,0,0,0.48);
                    color: white;
                    background-color: ${props.color ? darken(0.2, desaturate(0.1, lighten(0.4, props.color))) : darken(0.2, 'grey')};
                }
            `)
        }
            
    }}
`

const LabelWrapper = styled.div`
    padding: 5px 0;
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Molecules/SwitchButtons.jsx